import "./style.css";
import logo from "../../Images/logo.png";
import FacebookIcon from "../../Images/iconFooter/facebook.png";
import InstagramIcon from "../../Images/iconFooter/insta.png";
import YouTubeIcon from '../../Images/iconFooter/youtube.png';
import { Button } from "@mui/material";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailIcon from '@mui/icons-material/Mail';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Icons } from "../../Data/cardData";
export default function Footer() {
   const ref1 = useRef(null);
    const isInView1 = useInView(ref1, { once: true });
    const ref2 = useRef(null);
    const isInView2 = useInView(ref2, { once: true });
  return (
    <div className="footer">
    <div className="footerTop"   ref={ref1}
          style={{
            transform: isInView1 ? "none" : "translateX(-200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}>
     {iconsFooter.map((icon, index) => (
                    <div key={index} className="iconContainerFooter">
                        <img
                          src={require(`../../Images/iconFooter/${icon.name}.png`)}
                          alt={icon.name}
                          className="iconImgFooter"
                        />
                        <span>{icon.descreption}</span>
                    </div>
                  ))}
      </div>
      <div className="footerBottom" ref={ref2}
          style={{
            transform: isInView2 ? "none" : "translateX(200px)",
            opacity: isInView2 ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}>
      <div className="footLogo">
      <div>
      
        <img src={logo} alt="logo" className="logoFoot" />
        </div>
        <div className="socialFoot">
        <h2 style={{color:"#1976D2"}}>Retrouvez toutes nos actualités et suivez-nous !!</h2>
         <a href="https://www.facebook.com/ellouzealu.tn/" target="_blank" rel="noreferrer">
         <img src={FacebookIcon} alt="facebookIcon" />
         </a>
         <a href="https://www.instagram.com/ellouze_alu" target="_blank" rel="noreferrer">
         <img src={InstagramIcon} alt="instagramIcon" /></a>
         <a href="https://www.youtube.com/@EllouzeAlu" target="_blank" rel="noreferrer">
         <img src={YouTubeIcon} alt="youtubeIcon" /></a>
        </div>
      </div>
      
      <div className="foot">
      <div className="footMiddle">
        
        <h3>Nos produits</h3>
        
        {Icons.map((icon, index) => (
                    <a  href={`/nos-produits/${icon.nom}`}>
                       <h3 >{icon.nom} </h3>
                   </a>
                 ))}
                 </div>
                 <div className="footMiddle">
        
        <h3>Nos Réalisations </h3>
      
        <a href="/nos-realisations">professionnels </a>
      <a href="/nos-realisations">multiresidentiels </a>
        <a href="/nos-realisations">résidentiels </a>
                 </div>
      <div className="footMiddle last">
        
        <h3 >BESOIN D'AIDE? Nous sommes là pour vous </h3>
        
        <span>Hotline clients <SupportAgentIcon sx={{color:'#1976D2',marginLeft:'1px'}}/></span>
        <span>Lundi - vendredi : 8h - 17h</span>
         <span>Samedi : 8h - 14h</span>
        <a href="tel:58421628"><Button size="small"  sx={{color:'white',fontFamily:'Brown'}} startIcon={<LocalPhoneIcon sx={{color:'#1976D2'}}/>}>
        58 421 628</Button> </a>
        <a href="whatsapp://send?phone=+216 58421628"><Button size="small" sx={{color:'white',fontFamily:'Brown'}} startIcon={<WhatsAppIcon sx={{color:'#1976D2'}}/>}>
        58 421 628</Button> </a>
        <a href="mailto:ellouzealumarketing@gmail.com"><Button size="small" sx={{color:'white',fontFamily:'Brown'}} startIcon={<MailIcon sx={{color:'#1976D2'}}/>}>ellouzealumarketing@gmail.com</Button> </a>
      </div>
      </div>
      <div className="socialFootPower">
        Développé par   <a
                className="navLinkFoot"
                href="https://h4c.pro/"
              > by H4C </a>
               </div>
      </div>
    </div>
  );
}
const iconsFooter = [
  { name: "medal",descreption:'Depuis plus de 17 ans au service' },
  { name: "mesure",descreption:'100% sur mesure' },
  { name: "durable",descreption:'haute qualité qui se manifeste au niveau de la performance de nos produits.' },
  { name: "quality",descreption:'nos clients sont mis à l’honneur et au cœur de toutes les préoccupations.' },
  

];